var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import vueQr from 'vue-qr';
var BillHeader = (function (_super) {
    __extends(BillHeader, _super);
    function BillHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.treeData = [];
        _this.dialogFormVisible = true;
        _this.qrShow = false;
        _this.nameArr = [];
        _this.dialogBody = 1;
        return _this;
    }
    BillHeader.prototype.created = function () {
        var _this = this;
        Reflect.ownKeys(this.previewData).forEach(function (key) {
            console.log(_this.previewData, "!23132");
            _this.dialogBody = Number(_this.previewData[key].width) * 10;
            _this.previewName = _this.previewData[key].name;
            _this.previewData[key].qrcode_config.forEach(function (item) {
                item.lineId = [];
                item.lineIdXVal = [];
                item.nameXVal = item.x_coordinates + (item.fontSize * ((item.value ? item.value.length : 0) + 1));
                if (item.key == "qrcode" && !item.hidden) {
                    _this.qrShow = true;
                    _this.qrCodeText = item.value;
                    _this.qrCodeSize = item.width;
                    _this.qrCodeLeft = item.x_coordinates;
                    _this.qrCodeTop = item.y_coordinates;
                }
                if (item.key !== "qrcode" && !item.hidden) {
                    _this.nameArr.push(item);
                }
                if (!item.hidden && item.y_coordinates) {
                    _this.maxHeightItem = item.key;
                    _this.maxItemWidth = item.width;
                    _this.maxItemSize = item.fontSize;
                }
            });
            _this.previewData[key].qrcode_config.forEach(function (item, index) {
                var initKey = item.key;
                var initValue = item.y_coordinates;
                var initIndex = index;
                for (var x = 0; x < _this.previewData[key].qrcode_config.length; x++) {
                    if (!_this.previewData[key].qrcode_config[initIndex].hidden && x !== initIndex && (Math.abs(_this.previewData[key].qrcode_config[x].y_coordinates - initValue) < Number(_this.previewData[key].qrcode_config[x].fontSize) + 5) && !_this.previewData[key].qrcode_config[x].hasOwnProperty("isline")) {
                        _this.previewData[key].qrcode_config[x].isline = true;
                        _this.previewData[key].qrcode_config[x].lineId.push(initIndex);
                        _this.previewData[key].qrcode_config[x].lineIdXVal.push(_this.previewData[key].qrcode_config[initIndex].x_coordinates);
                    }
                    if (!_this.previewData[key].qrcode_config[initIndex].hidden && x !== initIndex && (Math.abs(_this.previewData[key].qrcode_config[x].y_coordinates - initValue) < Number(_this.previewData[key].qrcode_config[x].fontSize))) {
                        if (_this.previewData[key].qrcode_config[x].lineId.indexOf(initIndex) == -1) {
                            _this.previewData[key].qrcode_config[x].lineId.push(initIndex);
                            _this.previewData[key].qrcode_config[x].lineIdXVal.push(_this.previewData[key].qrcode_config[initIndex].x_coordinates);
                        }
                        ;
                    }
                    if (initKey == "qrcode") {
                        if (!_this.previewData[key].qrcode_config[initIndex].hidden && x !== initIndex && (Math.abs(_this.previewData[key].qrcode_config[x].y_coordinates - initValue) < Number(_this.previewData[key].qrcode_config[initIndex].height))) {
                            if (_this.previewData[key].qrcode_config[x].lineId.indexOf(initIndex) == -1) {
                                _this.previewData[key].qrcode_config[x].lineId.push(initIndex);
                                _this.previewData[key].qrcode_config[x].lineIdXVal.push(_this.previewData[key].qrcode_config[initIndex].x_coordinates);
                            }
                            ;
                        }
                    }
                    if (_this.previewData[key].qrcode_config[x].key == "qrcode") {
                        if (!_this.previewData[key].qrcode_config[initIndex].hidden && x !== initIndex && ((_this.previewData[key].qrcode_config[initIndex].y_coordinates + Number(_this.previewData[key].qrcode_config[initIndex].fontSize) < Number(_this.previewData[key].qrcode_config[x].y_coordinates + _this.previewData[key].qrcode_config[x].height)) && (_this.previewData[key].qrcode_config[initIndex].y_coordinates + Number(_this.previewData[key].qrcode_config[initIndex].fontSize) > Number(_this.previewData[key].qrcode_config[x].y_coordinates)))) {
                            if (_this.previewData[key].qrcode_config[x].lineId.indexOf(initIndex) == -1) {
                                _this.previewData[key].qrcode_config[x].lineId.push(initIndex);
                                _this.previewData[key].qrcode_config[x].lineIdXVal.push(_this.previewData[key].qrcode_config[initIndex].x_coordinates);
                            }
                            ;
                        }
                    }
                    if (x == _this.previewData[key].qrcode_config.length - 1) {
                        initIndex++;
                    }
                }
            });
            _this.previewData[key].qrcode_config.forEach(function (item) {
                for (var x = 0; x < _this.previewData[key].qrcode_config.length; x++) {
                    if (_this.previewData[key].qrcode_config[x].lineId.length) {
                        _this.previewData[key].qrcode_config[x].lineIdXVal = _this.previewData[key].qrcode_config[x].lineIdXVal.sort(function (a, b) { return a - b; });
                        var nextValue = "";
                        for (var z = 0; z < _this.previewData[key].qrcode_config[x].lineIdXVal.length; z++) {
                            if (_this.previewData[key].qrcode_config[x].lineIdXVal[z] > _this.previewData[key].qrcode_config[x].nameXVal) {
                                if (nextValue == "") {
                                    nextValue = _this.previewData[key].qrcode_config[x].lineIdXVal[z];
                                }
                            }
                        }
                        if (!nextValue) {
                            nextValue = _this.dialogBody;
                        }
                        if (nextValue || nextValue < _this.previewData[key].qrcode_config[x].nameXVal) {
                            var wordNum = Math.floor((Number(nextValue) - _this.previewData[key].qrcode_config[x].nameXVal) / Number(_this.previewData[key].qrcode_config[x].fontSize));
                            if (_this.previewData[key].qrcode_config[x].value && _this.previewData[key].qrcode_config[x].value !== null && _this.previewData[key].qrcode_config[x].value.length > wordNum) {
                                _this.previewData[key].qrcode_config[x].value = _this.previewData[key].qrcode_config[x].value.substring(0, wordNum) + (wordNum > 0 ? "..." : "");
                            }
                        }
                    }
                    ;
                    if (_this.previewData[key].qrcode_config[x].key !== "qrcode") {
                        if (!_this.previewData[key].qrcode_config[x].value) {
                            return;
                        }
                        if ((_this.previewData[key].qrcode_config[x].value.length + _this.previewData[key].qrcode_config[x].name.length) * _this.previewData[key].qrcode_config[x].fontSize > _this.dialogBody) {
                            var wordNum = Math.floor((Number(_this.dialogBody) - _this.previewData[key].qrcode_config[x].x_coordinates - (_this.previewData[key].qrcode_config[x].name.length * _this.previewData[key].qrcode_config[x].fontSize)) / Number(_this.previewData[key].qrcode_config[x].fontSize));
                            if (_this.previewData[key].qrcode_config[x].value && _this.previewData[key].qrcode_config[x].value !== null && _this.previewData[key].qrcode_config[x].value.length > wordNum) {
                                _this.previewData[key].qrcode_config[x].value = _this.previewData[key].qrcode_config[x].value.substring(0, wordNum - 1) + "...";
                            }
                        }
                    }
                }
            });
            console.log(_this.previewData[key].qrcode_config, "printData[key].qrcode_config");
        });
    };
    BillHeader.prototype.mounted = function () {
    };
    BillHeader.prototype.normalizer = function (node) {
        return {
            id: node.depot_id,
            label: node.depot_name,
            children: node.children,
        };
    };
    BillHeader.prototype.dialogClose = function () {
        this.$emit("dialogClose");
    };
    __decorate([
        Prop({
            type: Boolean,
            default: false,
        })
    ], BillHeader.prototype, "status", void 0);
    __decorate([
        Prop({
            type: Object,
            default: {},
        })
    ], BillHeader.prototype, "previewData", void 0);
    BillHeader = __decorate([
        Component({
            components: {
                vueQr: vueQr
            }
        })
    ], BillHeader);
    return BillHeader;
}(Vue));
export default BillHeader;
